<template>
  <v-card elevation="0" class="advisor-list-item mb-6 rounded-lg">
    <div class="advisor-list-item__main-data px-3 py-1">
      <a
        @click="$emit('navigate-to-advisor', profileId, null, advisorFullname)"
        class="advisor-list-item__column advisor-list-item__column--avatar"
      >
        <profile-preview-image
          :profileId="profileId"
          :thumbnailUrl="thumbnailUrl"
          :avatarSize="48"
          :avatarClasses="[
            'advisor-list-item__block--avatar',
            'avatar',
            'rounded-circle',
          ]"
          :imageClasses="['advisor-list-item__avatar']"
        />
        <div class="advisor-list-item__block">
          <p class="advisor-list-item__fullname">{{ advisorFullname }}</p>
          <p class="advisor-list-item__status">
            <span class="advisor-list-item__label advisor-list-item__active">{{
              isActive ? 'Active' : 'Inactive'
            }}</span>
          </p>
        </div>
      </a>
      <div
        class="advisor-list-item__block advisor-list-item__block--last-updated-swap"
      >
        <p v-if="lastUpdatedSwap" class="advisor-list-item__last-updated-swap">
          {{ lastUpdatedSwap | moment('MMMM Do, YYYY hh:mm A') }}
        </p>
        <p v-if="lastUpdatedSwap" class="advisor-list-item__label">
          {{ tenantTexts.advisorsDashboard.lastUpdatedSwap }}
        </p>
      </div>
      <div class="advisor-list-item__block advisor-list-item__notes-wrapper">
        <v-btn
          icon
          color="accent"
          elevation="0"
          @click="
            $emit('navigate-to-advisor', profileId, null, advisorFullname)
          "
        >
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="advisor-list-item__detail-data px-3 py-1">
      <span class="advisor-list-item__block">
        <p
          :class="
            `advisor-list-item__label advisor-list-item__label--indicator-${respondedStatus(
              'routines',
            )}`
          "
        >
          {{ tenantTexts.advisorsDashboard.routines }}:
          <strong>{{ positiveActions }}</strong>
        </p>
      </span>
      <v-tooltip open-delay="200" top>
        <template v-slot:activator="{ on, attrs }">
          <span class="advisor-list-item__block" v-bind="attrs" v-on="on">
            <p class="advisor-list-item__label advisor-list-item__rating">
              Rating&nbsp;<rating-stars
                :rating="ratingTotalRaw"
                :size="12"
              />&nbsp;<strong>{{ ratingTotal }}/5</strong>
            </p>
          </span>
        </template>
        <span
          >Rating Day: {{ ratingDay }}/5<br />Rating Actions:
          {{ ratingActions }}/5<br />Rating Total: {{ ratingTotal }}/5</span
        >
      </v-tooltip>
      <a
        @click="$emit('navigate-to-advisor', chatId, 'chat')"
        class="advisor-list-item__block"
      >
        <p
          :class="
            `advisor-list-item__label advisor-list-item__label--indicator-${respondedStatus(
              'chat',
            )}`
          "
        >
          Unread msg. <strong>{{ unreadChatMessages }}</strong>
        </p>
      </a>
      <v-tooltip open-delay="200" top>
        <template v-slot:activator="{ on, attrs }">
          <span class="advisor-list-item__block" v-bind="attrs" v-on="on">
            <p
              v-if="showJournal"
              :class="
                `advisor-list-item__label advisor-list-item__label--indicator-${respondedStatus(
                  'journal',
                )}`
              "
            >
              Journal entries <strong>{{ journalEntries }}</strong>
            </p>
          </span>
        </template>
        <span v-if="showJournal"
          >Unresponded entries: {{ unrespondedTotal }}</span
        >
      </v-tooltip>
      <span class="advisor-list-item__block">
        <p v-if="showSwaps" class="text-right advisor-list-item__label">
          {{ tenantTexts.advisorsDashboard.swaps }}
          <v-chip pill
            ><strong>{{ swapActivitiesTotal }}</strong
            >&nbsp;Added To</v-chip
          ><v-chip pill
            ><strong>{{ swapCompleted }}</strong
            >&nbsp;Completed</v-chip
          ><v-chip pill
            ><strong>{{ swapInProgress }}</strong
            >&nbsp;In progress</v-chip
          >
        </p>
      </span>
    </div>
  </v-card>
</template>

<script>
import TenantTextsMixin from '@/mixins/tenantTexts'
import ProfilePreviewImage from '../profile/ProfilePreviewImage.vue'
import RatingStars from '../exercises/RatingStars.vue'

export default {
  components: { ProfilePreviewImage, RatingStars },
  name: 'AdvisorListItem',
  mixins: [TenantTextsMixin],
  props: {
    showSwaps: {
      type: Boolean,
      required: false,
      default: true,
    },
    showJournal: {
      type: Boolean,
      required: false,
      default: true,
    },
    profileId: {
      type: Number,
      require: true,
    },
    chatId: {
      type: String,
      require: true,
    },
    isActive: {
      type: Boolean,
      require: true,
    },
    firstname: {
      type: String,
      require: true,
    },
    lastname: {
      type: String,
      require: true,
    },
    routinesTotal: {
      type: Number,
      require: false,
      default: 0,
    },
    positiveActions: {
      type: Number,
      require: false,
      default: 0,
    },
    journalEntries: {
      type: Number,
      require: false,
      default: 0,
    },
    swapNew: {
      type: Number,
      require: false,
      default: 0,
    },
    swapInProgress: {
      type: Number,
      require: false,
      default: 0,
    },
    swapCompleted: {
      type: Number,
      require: false,
      default: 0,
    },
    swapActivities: {
      type: Number,
      require: false,
      default: 0,
    },
    swapActivitiesTotal: {
      type: Number,
      require: false,
      default: 0,
    },
    total: {
      type: Number,
      require: false,
      default: 0,
    },
    unrespondedTotal: {
      type: Number,
      require: false,
      default: 0,
    },
    ratingSum: {
      type: Number,
      require: false,
      default: 0,
    },
    ratingCount: {
      type: Number,
      require: false,
      default: 0,
    },
    ratingDayCount: {
      type: Number,
      require: false,
      default: 0,
    },
    ratingDaySum: {
      type: Number,
      require: false,
      default: 0,
    },
    ratingActionsSum: {
      type: Number,
      require: false,
      default: 0,
    },
    ratingActionsCount: {
      type: Number,
      require: false,
      default: 0,
    },
    thumbnailUrl: {
      type: String,
      require: false,
      default: '',
    },
    lastUpdatedSwap: {
      type: String,
      require: false,
      default: '',
    },
    unreadChatMessages: {
      type: Number,
      require: false,
      default: 0,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    ratingTotalRaw() {
      if (this.ratingCount === 0) return 0
      return parseFloat(this.ratingSum / this.ratingCount)
    },
    ratingTotal() {
      if (this.ratingCount === 0) return 0
      return parseFloat(this.ratingSum / this.ratingCount).toFixed(1)
    },
    ratingDay() {
      if (this.ratingDayCount === 0) return 0
      return parseFloat(this.ratingDaySum / this.ratingDayCount).toFixed(1)
    },
    ratingActions() {
      if (this.ratingActionsCount === 0) return 0
      return parseFloat(
        this.ratingActionsSum / this.ratingActionsCount,
      ).toFixed(1)
    },
    advisorFullname() {
      let fullname = this.firstname
      if (fullname.length > 0) fullname += ' '
      fullname += this.lastname
      return fullname
    },
  },
  methods: {
    handleLoadStart() {
      this.isLoading = true
    },
    handleLoad() {
      this.isLoading = false
    },
    respondedStatus(type = '') {
      let status = ''
      switch (type) {
        case 'routines':
          if (!this.positiveActions) status = 'no-data'
          else if (this.positiveActions > 0) status = 'responded'
          break
        case 'chat':
          if (this.unreadChatMessages > 0) status = 'not-responded'
          else status = 'responded'
          break
        case 'journal':
          if (!this.journalEntries) status = 'no-data'
          else if (this.unrespondedTotal > 0 && this.journalEntries)
            status = 'not-responded'
          else if (!this.unrespondedTotal && this.journalEntries)
            status = 'responded'
          break
        default:
          status = ''
      }

      return status
    },
  },
}
</script>

<style lang="scss">
.advisor-list-item {
  min-width: 800px;

  &__rating,
  &__main-data,
  &__detail-data {
    display: flex;
    align-items: center;
  }

  &__main-data,
  &__detail-data {
    flex-wrap: wrap;

    > .advisor-list-item__block:not(.advisor-list-item__block--last-updated-swap),
    > .advisor-list-item__column {
      min-width: 150px;
      flex: 1;
      padding: 0.25 * $gutter;
      @media (max-width: 1400px) {
        max-width: 160px;
        min-width: auto;
      }

      &:first-child {
        min-width: 275px;
        @media (max-width: 1400px) {
          max-width: 200px;
          min-width: auto;
        }
      }

      &:last-child {
        justify-items: flex-end;
        min-width: 415px;
      }
    }
  }

  &__main-data {
    margin: -0.25 * $gutter;
  }

  &__detail-data {
    margin: -0.25 * $gutter;
    border-top: 1px solid $bh-gray--4;
  }

  &__column {
    display: flex;
  }

  &__block {
    flex: 1;
    color: inherit !important;

    p {
      margin-bottom: 0;
    }

    &--avatar {
      margin-right: 0.5 * $gutter;
    }

    .v-chip {
      font-size: 12px;
      cursor: inherit;
      margin-left: 0.5 * $gutter;
      background-color: $bh-gray--6 !important;
    }
  }

  &__phone {
    color: inherit !important;
  }

  &__registration-date {
    color: $bh-gray;
  }

  &__active {
    margin-right: 0.5 * $gutter;
  }

  &__active,
  &__fullname {
    color: #000;
  }

  &__notes {
    &-wrapper {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    &-tooltip {
      max-width: 800px;
      display: inline-block;
    }

    flex: 1;
    font-size: 12px;
    line-height: 16px;
    max-height: 48px;
    position: relative;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  &__label {
    font-size: 12px;
    line-height: 22px;
    color: $bh-black;

    strong {
      color: #000;
    }
  }

  .rating-stars .v-icon {
    margin-right: 5px;
  }

  &__detail-data {
    .advisor-list-item__label--indicator {
      &-responded,
      &-no-data,
      &-not-responded {
        display: inline-block;
        padding-left: 16px;
        position: relative;

        &::before {
          content: ' ';
          width: 8px;
          height: 8px;
          border-radius: 4px;
          position: absolute;
          top: calc(50% - 4px);
          left: 0;
          background-color: $bh-blue;
        }
      }
      &-responded::before {
        background-color: $bh-green;
      }
      &-no-data::before {
        background-color: $bh-gray--4;
      }
    }
  }
}
</style>
